import React from 'react';
import PropTypes from 'prop-types';
import Card from '../card';

import {
  MAX_BOOKINGS_OPTIONS,
  MAX_BOOKINGS_TEXT,
  NOTICE_BEFORE_BOOKINGS_TEXT,
  NOTICE_BOOKINGS_OPTIONS,
  STATUS_OPTIONS,
  TIME_BETWEEN_BOOKINGS_TEXT,
} from '../constants';

import {
  Container,
  ContainerDropdown,
  Dropdown,
  Text,
} from './styles';

const Settings = (props) => {
  const {
    bookingNotice,
    bufferTime,
    maxBookings,
    onChange,
  } = props;

  const handleChange = (e, { value, name }) => {
    onChange(name, value);
  };

  return (
    <Card
      title="Settings"
    >
      <Container>
        <ContainerDropdown>
          <Text>{TIME_BETWEEN_BOOKINGS_TEXT}</Text>
          <Dropdown
            selection
            options={STATUS_OPTIONS}
            placeholder="Status"
            value={bufferTime}
            onChange={handleChange}
            name="bufferTime"
          />
        </ContainerDropdown>

        <ContainerDropdown>
          <Text>{NOTICE_BEFORE_BOOKINGS_TEXT}</Text>
          <Dropdown
            selection
            options={NOTICE_BOOKINGS_OPTIONS}
            value={bookingNotice}
            onChange={handleChange}
            name="bookingNotice"
          />
        </ContainerDropdown>

        <ContainerDropdown>
          <Text>{MAX_BOOKINGS_TEXT}</Text>
          <Dropdown
            selection
            options={MAX_BOOKINGS_OPTIONS}
            value={maxBookings}
            onChange={handleChange}
            name="maxBookings"
          />
        </ContainerDropdown>
      </Container>
    </Card>
  );
};

Settings.propTypes = {
  bookingNotice: PropTypes.number.isRequired,
  bufferTime: PropTypes.number.isRequired,
  maxBookings: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Settings;
